export default __webpack_public_path__ + "static/gloves-cropped-c6c0769fb55b72a6e8db132da8f1a07d.webp";